<template>
<section class="apartment-filter">

    <div class="container">
        <form class="apartment-filter__row">
            <div class="apartment-filter__filters">
                <div class="apartment-filter__wrap apartment-filter__wrap--rooms">
                    <label class="apartment-filter__label">
                        Количество комнат
                    </label>
                  <div class="apartment-filter__flex">
                    <div class="apartment-filter__checkbox" v-for="room in roomsList">
                      <label class="form-checkbox ">
                        <input type="checkbox" :value="room" v-model="form.rooms" class="form-checkbox__input">
                        {{room}}
                        <span class="form-checkbox__checkmark" ></span>
                      </label>
                    </div>
                  </div>

                </div>

                <div class="apartment-filter__wrap apartment-filter__wrap--price">
                  <label class="apartment-filter__label">
                    Стоимость квартиры (₽)
                  </label>
                  <vue-slider tooltip="none" v-model="price" :min="0" :max="10000000"/>
                  <div class="apartment-filter__flex">

                    <div class="apartment-filter__input">
                      <label class="input-group">
                        <number-input placeholder="От"
                                      :input-class="'input-group__input'"
                                      v-model="price[0]"
                                      ></number-input>

                      </label>
                    </div>

                    <div class="apartment-filter__input">
                      <label class="input-group ">
                        <span class="input-group__text">До</span>
                        <number-input placeholder="До"
                                      :input-class="'input-group__input'"
                                      v-model="price[1]"
                        ></number-input>
                      </label>
                    </div>
                  </div>

                </div>
                <div class="apartment-filter__wrap  apartment-filter__wrap--square">
                  <label class="apartment-filter__label">
                    Площадь (м<sup>2</sup>)
                  </label>
                  <vue-slider tooltip="none" v-model="square" :min="0" :max="200"/>
                  <div class="apartment-filter__flex">
                    <div class="apartment-filter__input">
                      <label class="input-group">
                        <number-input placeholder="От"
                                      :input-class="'input-group__input'"
                                      v-model="square[0]"
                        ></number-input>
                      </label>
                    </div>

                    <div class="apartment-filter__input">
                      <label class="input-group ">
                        <span class="input-group__text">До</span>
                        <number-input placeholder="До"
                                      :input-class="'input-group__input'"
                                      v-model="square[1]"
                        ></number-input>
                      </label>
                    </div>
                  </div>
                </div>
            </div>

            <div class="apartment-filter__btns" :class="{ 'apartment-filter__btns--filtered': filtered }">
              <button @click.prevent="clearFilter" class="btn button-link" v-if="filtered">
                <i class="fas fa-times" aria-hidden="true"></i>
                <span class="button-link__text">Сбросить</span>
              </button>
                <button class="btn   button-black apartment-filter__btn" @click.prevent="filterSubmit" >
                    Применить
                </button>
            </div>

        </form>
    </div>
</section>
</template>
<script>
import VueSlider from 'vue-slider-component'
import NumberInput from '../../common/number-input'
    export default {
        components: {
          VueSlider,NumberInput
        },
        props:['roomsList'],
        data() {
          return {
              form: {
                  rooms: [],
                  price_from:'',
                  price_to:'',
                  square_from:'',
                  square_to:''
              },
            price:[0,10000000],
            square:[0, 200],
              filtered:false,
          }
        },
        methods: {
            filterSubmit() {
              this.form.price_from = this.price[0];
              this.form.price_to = this.price[1];
              this.form.square_from = this.square[0];
              this.form.square_to = this.square[1];
              if(this.form.rooms.length > 0 || this.form.price_from || this.form.price_to || this.form.square_from || this.form.square_to ) {
                this.$emit('filterSubmit', this.form);
                this.filtered = true;
              }
            },
            clearFilter() {
                for (var key in this.form) {
                    if(Array.isArray(this.form[key])) {
                        this.form[key] = [];
                    } else {
                        this.form[key] = '';
                    }

                }
                this.filtered = false;
                this.$emit('clearFilter');
            }
        }
    }
</script>